import Device from '@components/Device/Device';
import type { PropsWithChildren } from 'react';

import * as styles from './MobileCardPreview.css';

interface MobileCardPreviewProps {
  loading?: boolean;
}

const MobileCardPreview: React.FC<PropsWithChildren<MobileCardPreviewProps>> = ({
  children,
  loading = false,
}) => (
  <div className={styles.mobilePreview} data-loading={loading}>
    <Device type="iphone" notch={false}>
      <div className={styles.screenContent}>{children}</div>
    </Device>
  </div>
);

export default MobileCardPreview;
